export enum BuildMode {
  development = "development",
  beta = "beta",
  production = "production",
}
